/**
 * Single source for applying client-defined styles (font) to the document.
 */
const DEFAULT_FONT = 'Arial, Helvetica, sans-serif';

const GOOGLE_FONTS = new Set([
  'Inter', 'Quicksand', 'Urbanist', 'Karla', 'Raleway', 'Roboto Flex', 'Roboto Slab',
  'Merriweather Sans', 'Abril Fatface', 'Playfair Display', 'Libre Baskerville',
  'Old Standard TT', 'Cormorant Garamond', 'EB Garamond', 'Lora', 'Oxygen',
  'PT Sans Narrow', 'Zilla Slab', 'Heebo', 'Assistant'
]);

function loadGoogleFont(fontFamily) {
  const match = fontFamily.match(/^['"]?([^,'"]+)['"]?/);
  const name = match ? match[1].trim() : '';
  if (!name || !GOOGLE_FONTS.has(name)) return;
  const familyParam = name.replace(/\s+/g, '+');
  const href = `https://fonts.googleapis.com/css2?family=${familyParam}:wght@400;600&display=swap`;
  const existing = document.querySelectorAll('link[href*="fonts.googleapis.com"]');
  if ([...existing].some(link => link.href.includes('family=' + familyParam))) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

export function applyFontFromClient(clientData) {
  if (!clientData) return;
  const font = clientData.fontFamily?.trim() || DEFAULT_FONT;
  document.documentElement.style.setProperty('--font-primary', font);
  loadGoogleFont(font);
}
